module.exports = __webpack_public_path__ + "img/logo-te.6ce9f386.png";